<script lang="ts">
  import { operationStore, query } from "@urql/svelte";
  import Loader from "./Loader.svelte";

  let name = "";
  let limit = 200;
  let offset = 0;

  const pokemons = operationStore(
    `
    query($limit: Int!, $offset: Int!) {
      pokemons(limit: $limit, offset: $offset) {
        results {
          name
        }
      }
    }
  `,
    { limit, offset },
    { requestPolicy: "cache-and-network" }
  );

  let pokeType: string = "";

  $: {
    if ($qres.data) {
      pokeType = qres.data.pokemonByName.types[0].type.name;
    }
  }

  const qres = operationStore(
    `
    query($name: String!) {
      pokemonByName(name: $name) {
        id
        name
        weight
        height
        types {
          slot
          type {
            name
            url
          }
        }
        types {
          type {
            name
          }
        }
        sprites {
          versions {
            generationI {
              redBlue {
                frontDefault
              }
            }
          }
        }
      }
    }
  `,
    { name },
    { requestPolicy: "cache-and-network" }
  );

  const showList = () => {
    $qres.variables.name = "";
  };

  const changeName = (val: string) => {
    $qres.variables.name = val;
  };

  query(qres);
  query(pokemons);
</script>

<div id="pokedex">
  <div id="left">
    <!-- <div id="logo" /> -->
    <div id="bg_curve1_left" />
    <div id="bg_curve2_left" />
    <div id="curve1_left">
      <div id="buttonGlass">
        <div id="reflect" />
      </div>
      <div id="miniButtonGlass1" />
      <div id="miniButtonGlass2" />
      <div id="miniButtonGlass3" />
    </div>
    <div id="curve2_left">
      <div id="junction">
        <div id="junction1" />
        <div id="junction2" />
      </div>
    </div>
    <div id="screen">
      <div id="topPicture">
        <div id="buttontopPicture1" />
        <div id="buttontopPicture2" />
      </div>
      <div id="picture">
        {#if $pokemons.fetching || $pokemons.error}
          <Loader />
        {:else if $qres.variables.name.length === 0}
          <ul>
            {#each $pokemons.data.pokemons.results as pk (pk.name)}
              <li on:click={() => changeName(pk.name)}>
                {pk.name}
              </li>
            {/each}
          </ul>
        {:else if $qres.fetching}
          <Loader />
        {:else if $qres.error}
          <p>Please try again.</p>
        {:else}
          <img
            src={$qres.data.pokemonByName.sprites.versions.generationI.redBlue
              .frontDefault}
            alt={"pokemon image"}
            height="170"
          />
        {/if}
      </div>
      <div id="buttonbottomPicture" />
      <div id="speakers" on:click={showList}>
        <div class="sp" />
        <div class="sp" />
        <div class="sp" />
        <div class="sp" />
      </div>
    </div>
    <div id="bigbluebutton" />
    <div id="barbutton1" />
    <div id="barbutton2" />
    <div id="cross">
      <div id="leftcross">
        <div id="leftT" />
      </div>
      <div id="topcross">
        <div id="upT" />
      </div>
      <div id="rightcross">
        <div id="rightT" />
      </div>
      <div id="midcross">
        <div id="midCircle" />
      </div>
      <div id="botcross">
        <div id="downT" />
      </div>
    </div>
  </div>
  <div id="right">
    <div id="stats">
      {#if $qres.variables.name.length === 0}
        <p>Please select a Pokemon.</p>
      {:else if $qres.fetching}
        <Loader />
      {:else if $qres.error}
        <p>Please try again.</p>
      {:else}
        <strong>Name:</strong>
        <span class="capitalize">{qres.data.pokemonByName.name}</span><br />
        <strong>ID:</strong>
        <span class="capitalize">{qres.data.pokemonByName.id}</span><br />
        <strong>Type:</strong> <span class="capitalize">{pokeType}</span><br />
        <strong>Height:</strong>
        {qres.data.pokemonByName.height}''<br />
        <strong>Weight:</strong>
        {qres.data.pokemonByName.weight} lbs.<br /><br />
      {/if}
    </div>
    <div id="blueButtons1">
      <div class="blueButton" />
      <div class="blueButton" />
      <div class="blueButton" />
      <div class="blueButton" />
      <div class="blueButton" />
    </div>
    <div id="blueButtons2">
      <div class="blueButton" />
      <div class="blueButton" />
      <div class="blueButton" />
      <div class="blueButton" />
      <div class="blueButton" />
    </div>
    <div id="miniButtonGlass4" />
    <div id="miniButtonGlass5" />
    <div id="barbutton3" />
    <div id="barbutton4" />
    <div id="yellowBox1" />
    <div id="yellowBox2" />
    <div id="bg_curve1_right" />
    <div id="bg_curve2_right" />
    <div id="curve1_right" />
    <div id="curve2_right" />
  </div>
</div>

<style>
  * {
    margin: 0;
    padding: 0;
  }

  ul {
    max-height: 100%;
    overflow-y: scroll;
    padding: 0.5em;
    list-style: none;
  }

  li {
    margin-bottom: 0.5em;
    cursor: pointer;
  }

  div#pokedex {
    margin: 0;
  }

  @media all {
    div#pokedex {
      width: 750px;
      margin: 50px auto 0 auto;
      max-width: 100%;
    }

    div#left {
      width: 400px;
      height: 500px;
      float: left;
      position: relative;
      z-index: 1;
    }

    div#right {
      width: 350px;
      height: 500px;
      float: left;
      position: relative;
    }

    /* //// LEFT PART //// */

    div#curve1_left {
      width: 201px;
      height: 85px;
      background-color: #8b0000;
      float: left;
      padding: 15px 0 0 15px;

      position: absolute;
      top: 0;
      left: 0;

      box-shadow: -10px 9px #5e0000;
      -webkit-box-shadow: -10px 9px #5e0000;
      -moz-box-shadow: -10px 9px #5e0000;
      -o-box-shadow: -10px 9px #5e0000;

      border-bottom-right-radius: 85px 60px;
      -webkit-border-bottom-right-radius: 85px 60px;
      -moz-border-bottom-right-radius: 85px 60px;
      -o-border-bottom-right-radius: 85px 60px;

      border-top-left-radius: 30px;
      -webkit-border-top-left-radius: 30px;
      -moz-border-top-left-radius: 30px;
      -o-border-top-left-radius: 30px;
    }

    div#bg_curve1_left {
      width: 400px;
      height: 80px;
      background-color: #8b0000;

      border-top-left-radius: 30px;
      -webkit-border-top-left-radius: 30px;
      -moz-border-top-left-radius: 30px;
      -o-border-top-left-radius: 30px;
    }

    div#curve2_left {
      width: 216px;
      height: 451px;
      background-color: #c00d0d;
      float: right;

      position: absolute;
      bottom: 0;
      right: 0;

      border-top-left-radius: 85px 60px;
      -webkit-border-top-left-radius: 85px 60px;
      -moz-border-top-left-radius: 85px 60px;
      -o-border-top-left-radius: 85px 60px;
    }

    div#bg_curve2_left {
      width: 400px;
      height: 420px;
      background-color: #c00d0d;

      box-shadow: -10px 9px #5e0000;
      -webkit-box-shadow: -10px 9px #5e0000;
      -moz-box-shadow: -10px 9px #5e0000;
      -o-box-shadow: -10px 9px #5e0000;

      border-bottom-left-radius: 30px;
      -webkit-border-bottom-left-radius: 30px;
      -moz-border-bottom-left-radius: 30px;
      -o-border-bottom-left-radius: 30px;
    }

    div#buttonGlass {
      width: 60px;
      height: 60px;
      margin-right: 15px;
      border: 5px solid #fff;
      float: left;

      box-shadow: 0 0 10px #490000;
      -webkit-box-shadow: 0 0 10px #490000;
      -moz-box-shadow: 0 0 10px #490000;
      -o-box-shadow: 0 0 10px #490000;

      background: radial-gradient(#05fbfb, #29abe3);
      background: -webkit-radial-gradient(#05fbfb, #29abe3);
      background: -moz-radial-gradient(#05fbfb, #29abe3);
      background: -o-radial-gradient(#05fbfb, #29abe3);

      border-radius: 35px;
      -webkit-border-radius: 35px;
      -moz-border-radius: 35px;
      -o-border-radius: 35px;
    }

    div#reflect {
      width: 30px;
      height: 18px;
      margin: 3px 0 0 15px;
      background: #fff;
      opacity: 0.6;

      border-radius: 15px 9px;
      -webkit-border-radius: 15px 9px;
      -moz-border-radius: 15px 9px;
      -o-border-radius: 15px 9px;
    }

    div#miniButtonGlass1 {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      float: left;

      box-shadow: 0 0 10px #490000;
      -webkit-box-shadow: 0 0 10px #490000;
      -moz-box-shadow: 0 0 10px #490000;
      -o-box-shadow: 0 0 10px #490000;

      border-radius: 20px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      -o-border-radius: 20px;

      background: radial-gradient(#fb7b7b, #fb0505);
      background: -webkit-radial-gradient(#fb7b7b, #fb0505);
      background: -moz-radial-gradient(#fb7b7b, #fb0505);
      background: -o-radial-gradient(#fb7b7b, #fb0505);
    }

    div#miniButtonGlass2 {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      float: left;

      box-shadow: 0 0 10px #490000;
      -webkit-box-shadow: 0 0 10px #490000;
      -moz-box-shadow: 0 0 10px #490000;
      -o-box-shadow: 0 0 10px #490000;

      border-radius: 20px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      -o-border-radius: 20px;

      background: radial-gradient(#fbfb9b, #fbfb05);
      background: -webkit-radial-gradient(#fbfb9b, #fbfb05);
      background: -moz-radial-gradient(#fbfb9b, #fbfb05);
      background: -o-radial-gradient(#fbfb9b, #fbfb05);
    }

    div#miniButtonGlass3 {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      float: left;

      box-shadow: 0 0 10px #490000;
      -webkit-box-shadow: 0 0 10px #490000;
      -moz-box-shadow: 0 0 10px #490000;
      -o-box-shadow: 0 0 10px #490000;

      border-radius: 20px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      -o-border-radius: 20px;

      background: radial-gradient(#b0fb7b, #50fb05);
      background: -webkit-radial-gradient(#b0fb7b, #50fb05);
      background: -moz-radial-gradient(#b0fb7b, #50fb05);
      background: -o-radial-gradient(#b0fb7b, #50fb05);
    }

    div#junction {
      width: 60px;
      height: 451px;
      float: right;

      background: linear-gradient(left, #8b0000 0%, #c00d0d 50%, #8b0000 100%);
      background: -webkit-linear-gradient(
        left,
        #8b0000 0%,
        #c00d0d 50%,
        #8b0000 100%
      );
      background: -moz-linear-gradient(
        left,
        #8b0000 0%,
        #c00d0d 50%,
        #8b0000 100%
      );
      background: -o-linear-gradient(
        left,
        #8b0000 0%,
        #c00d0d 50%,
        #8b0000 100%
      );
    }

    div#junction1 {
      height: 40px;
      background-color: #5e0000;
      opacity: 0.3;
      margin-top: 50px;
      margin-bottom: 262px;

      border-top: 2px solid #330000;
      border-bottom: 2px solid #330000;
    }

    div#junction2 {
      height: 40px;
      background-color: #5e0000;
      opacity: 0.3;

      border-top: 2px solid #330000;
      border-bottom: 2px solid #330000;
    }

    div#screen {
      height: 245px;
      width: 260px;
      padding: 0 20px;
      background-color: #b0b0b0;
      float: left;

      position: absolute;
      top: 130px;
      left: 19px;

      border-radius: 15px;
      -webkit-border-radius: 15px;
      -moz-border-radius: 15px;
      -o-border-radius: 15px;
    }

    div#screen:after {
      content: "";
      border-top: 40px solid #b0b0b0;
      border-left: 40px solid #c00d0d;
      height: 0;

      position: absolute;
      bottom: 0;
      left: 0;
    }

    div#picture {
      height: 175px;
      width: 254px;
      margin-top: 20px;
      margin-bottom: 9px;
      background-color: #fff;
      border: 3px solid #494949;
      clear: both;

      border-radius: 15px;
      -webkit-border-radius: 15px;
      -moz-border-radius: 15px;
      -o-border-radius: 15px;
    }

    div#picture img {
      display: block;
      margin: 0 auto;
    }

    div#topPicture {
      margin: 6px auto;
      width: 40px;
    }

    div#buttontopPicture1,
    div#buttontopPicture2 {
      height: 8px;
      width: 8px;
      background-color: #c00d0d;
      border: 1px solid #000;
      float: left;

      border-radius: 15px;
      -webkit-border-radius: 15px;
      -moz-border-radius: 15px;
      -o-border-radius: 15px;
    }

    div#buttontopPicture1 {
      margin-right: 20px;
    }

    div#buttonbottomPicture {
      height: 26px;
      width: 26px;
      background-color: #c00d0d;
      margin-left: 35px;
      float: left;

      border-radius: 30px;
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -o-border-radius: 30px;

      box-shadow: -2px 1px #5e0000;
      -webkit-box-shadow: -2px 1px #5e0000;
      -moz-box-shadow: -2px 1px #5e0000;
      -o-box-shadow: -2px 1px #5e0000;

      background: linear-gradient(top, #c00d0d 0%, #8b0000 80%);
      background: -webkit-linear-gradient(top, #c00d0d 0%, #8b0000 80%);
      background: -moz-linear-gradient(top, #c00d0d 0%, #8b0000 80%);
      background: -o-linear-gradient(top, #c00d0d 0%, #8b0000 80%);
    }

    div#speakers {
      float: right;
      width: 75px;
      height: 25px;
      margin-right: 20px;
      cursor: pointer;
    }

    div.sp {
      height: 3px;
      margin-bottom: 5px;
      background-color: #494949;

      border-radius: 30px;
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -o-border-radius: 30px;
    }

    div#bigbluebutton {
      height: 50px;
      width: 50px;
      background-color: #000;

      position: absolute;
      top: 395px;
      left: 30px;

      border-radius: 100px;
      -webkit-border-radius: 100px;
      -moz-border-radius: 100px;
      -o-border-radius: 100px;

      background: linear-gradient(top, #307bfb 0%, #0530e5 80%);
      background: -webkit-linear-gradient(top, #307bfb 0%, #0530e5 80%);
      background: -moz-linear-gradient(top, #307bfb 0%, #0530e5 80%);
      background: -o-linear-gradient(top, #307bfb 0%, #0530e5 80%);

      box-shadow: -3px 2px #001c91;
      -webkit-box-shadow: -3px 2px #001c91;
      -moz-box-shadow: -3px 2px #001c91;
      -o-box-shadow: -3px 2px #001c91;
    }

    div#barbutton1 {
      height: 13px;
      width: 50px;

      position: absolute;
      top: 405px;
      left: 100px;

      border-radius: 100px;
      -webkit-border-radius: 100px;
      -moz-border-radius: 100px;
      -o-border-radius: 100px;

      background: linear-gradient(top, #50fb05 0%, #057b05 100%);
      background: -webkit-linear-gradient(top, #50fb05 0%, #057b05 100%);
      background: -moz-linear-gradient(top, #50fb05 0%, #057b05 100%);
      background: -o-linear-gradient(top, #50fb05 0%, #057b05 100%);

      box-shadow: -1px 2px #004200;
      -webkit-box-shadow: -1px 2px #004200;
      -moz-box-shadow: -1px 2px #004200;
      -o-box-shadow: -1px 2px #004200;
    }

    div#barbutton2 {
      height: 13px;
      width: 50px;

      position: absolute;
      top: 405px;
      left: 165px;

      border-radius: 100px;
      -webkit-border-radius: 100px;
      -moz-border-radius: 100px;
      -o-border-radius: 100px;

      background: linear-gradient(top, #fb6505 0%, #bb0505 100%);
      background: -webkit-linear-gradient(top, #fb6505 0%, #bb0505 100%);
      background: -moz-linear-gradient(top, #fb6505 0%, #bb0505 100%);
      background: -o-linear-gradient(top, #fb6505 0%, #bb0505 100%);

      box-shadow: -1px 2px #7b0000;
      -webkit-box-shadow: -1px 2px #7b0000;
      -moz-box-shadow: -1px 2px #7b0000;
      -o-box-shadow: -1px 2px #7b0000;
    }

    div#cross {
      width: 90px;
      height: 90px;

      position: absolute;
      top: 394px;
      left: 230px;
    }

    div#topcross {
      width: 30px;
      height: 30px;
      background-color: #222;

      position: absolute;
      top: 0;
      left: 30px;

      box-shadow: -3px 2px #010101;
      -webkit-box-shadow: -3px 2px #010101;
      -moz-box-shadow: -3px 2px #010101;
      -o-box-shadow: -3px 2px #010101;

      border-top-left-radius: 5px;
      -webkit-border-top-left-radius: 5px;
      -moz-border-top-left-radius: 5px;
      -o-border-top-left-radius: 5px;

      border-top-right-radius: 5px;
      -webkit-border-top-right-radius: 5px;
      -moz-border-top-right-radius: 5px;
      -o-border-top-right-radius: 5px;
    }

    div#leftcross {
      width: 30px;
      height: 30px;
      background-color: #222;
      z-index: 1;

      position: absolute;
      left: 0;
      top: 30px;

      box-shadow: -3px 2px #010101;
      -webkit-box-shadow: -3px 2px #010101;
      -moz-box-shadow: -3px 2px #010101;
      -o-box-shadow: -3px 2px #010101;

      border-top-left-radius: 5px;
      -webkit-border-top-left-radius: 5px;
      -moz-border-top-left-radius: 5px;
      -o-border-top-left-radius: 5px;

      border-bottom-left-radius: 5px;
      -webkit-border-bottom-left-radius: 5px;
      -moz-border-bottom-left-radius: 5px;
      -o-border-bottom-left-radius: 5px;
    }

    div#midcross {
      width: 30px;
      height: 30px;
      background-color: #222;

      position: absolute;
      top: 30px;
      left: 30px;

      box-shadow: -3px 2px #010101;
      -webkit-box-shadow: -3px 2px #010101;
      -moz-box-shadow: -3px 2px #010101;
      -o-box-shadow: -3px 2px #010101;
    }

    div#rightcross {
      width: 30px;
      height: 30px;
      background-color: #222;

      position: absolute;
      top: 30px;
      right: 0;

      box-shadow: -3px 2px #010101;
      -webkit-box-shadow: -3px 2px #010101;
      -moz-box-shadow: -3px 2px #010101;
      -o-box-shadow: -3px 2px #010101;

      border-top-right-radius: 5px;
      -webkit-border-top-right-radius: 5px;
      -moz-border-top-right-radius: 5px;
      -o-border-top-right-radius: 5px;

      border-bottom-right-radius: 5px;
      -webkit-border-bottom-right-radius: 5px;
      -moz-border-bottom-right-radius: 5px;
      -o-border-bottom-right-radius: 5px;
    }

    div#botcross {
      width: 30px;
      height: 30px;
      background-color: #222;

      position: absolute;
      bottom: 0;
      left: 30px;

      box-shadow: -3px 2px #010101;
      -webkit-box-shadow: -3px 2px #010101;
      -moz-box-shadow: -3px 2px #010101;
      -o-box-shadow: -3px 2px #010101;

      border-bottom-left-radius: 5px;
      -webkit-border-bottom-left-radius: 5px;
      -moz-border-bottom-left-radius: 5px;
      -o-border-bottom-left-radius: 5px;

      border-bottom-right-radius: 5px;
      -webkit-border-bottom-right-radius: 5px;
      -moz-border-bottom-right-radius: 5px;
      -o-border-bottom-right-radius: 5px;
    }

    div#upT {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #111;

      position: absolute;
      top: 5px;
      left: 4px;
    }

    div#downT {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #111;

      position: absolute;
      bottom: 5px;
      left: 4px;
    }

    div#leftT {
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-right: 10px solid #111;
      border-bottom: 10px solid transparent;

      position: absolute;
      top: 5px;
      left: 4px;
    }

    div#rightT {
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-left: 10px solid #111;
      border-bottom: 10px solid transparent;

      position: absolute;
      top: 5px;
      right: 5px;
    }

    div#midCircle {
      width: 20px;
      height: 20px;

      position: absolute;
      top: 5px;
      left: 4px;

      border-radius: 30px;
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -o-border-radius: 30px;

      background: radial-gradient(#111, #222);
      background: -webkit-radial-gradient(#111, #222);
      background: -moz-radial-gradient(#111, #222);
      background: -o-radial-gradient(#111, #222);
    }

    /* //// RIGHT PART //// */

    div#curve1_right {
      width: 166px;
      height: 451px;
      background-color: #c00d0d;
      float: right;

      position: absolute;
      bottom: 0;
      left: 0;

      border-top-right-radius: 85px 60px;
      -webkit-border-right-left-radius: 85px 60px;
      -moz-border-right-left-radius: 85px 60px;
      -o-border-right-left-radius: 85px 60px;
    }

    div#bg_curve1_right {
      width: 350px;
      height: 80px;
      background-color: transparent;

      border-top-right-radius: 30px;
      -webkit-border-top-right-radius: 30px;
      -moz-border-top-right-radius: 30px;
      -o-border-top-right-radius: 30px;
    }

    div#curve2_right {
      width: 216px;
      height: 100px;
      background-color: transparent;
      float: left;

      position: absolute;
      top: 0;
      right: 0;

      border-bottom-left-radius: 85px 60px;
      -webkit-border-bottom-left-radius: 85px 60px;
      -moz-border-bottom-left-radius: 85px 60px;
      -o-border-bottom-left-radius: 85px 60px;
    }

    div#bg_curve2_right {
      width: 350px;
      height: 420px;
      background-color: #c00d0d;

      border-bottom-right-radius: 30px;
      -webkit-border-bottom-right-radius: 30px;
      -moz-border-bottom-right-radius: 30px;
      -o-border-bottom-right-radius: 30px;

      box-shadow: -10px 9px #5e0000;
      -webkit-box-shadow: -10px 9px #5e0000;
      -moz-box-shadow: -10px 9px #5e0000;
      -o-box-shadow: -10px 9px #5e0000;
    }

    div#stats {
      height: 130px;
      width: 280px;
      padding: 10px;
      background-color: #30da0c;
      z-index: 1;
      font-size: 13px;
      font-family: arial, sans-serif;

      position: absolute;
      top: 130px;
      left: 25px;

      border-radius: 15px;
      -webkit-border-radius: 15px;
      -moz-border-radius: 15px;
      -o-border-radius: 15px;

      box-shadow: 0 0 20px #003300 inset;
      -webkit-box-shadow: 0 0 20px #003300 inset;
      -moz-box-shadow: 0 0 20px #003300 inset;
      -o-box-shadow: 0 0 20px #003300 inset;
    }

    div#blueButtons1 {
      z-index: 1;

      position: absolute;
      top: 295px;
      left: 49px;
    }

    div#blueButtons2 {
      z-index: 1;

      position: absolute;
      top: 335px;
      left: 49px;
    }

    div.blueButton {
      height: 35px;
      width: 45px;
      background-color: #003300;
      float: left;
      margin-right: 7px;

      border-radius: 10px;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      -o-border-radius: 10px;

      background: linear-gradient(top, #307bfb 0%, #0530e5 80%);
      background: -webkit-linear-gradient(top, #307bfb 0%, #0530e5 80%);
      background: -moz-linear-gradient(top, #307bfb 0%, #0530e5 80%);
      background: -o-linear-gradient(top, #307bfb 0%, #0530e5 80%);

      box-shadow: -1px 2px #001c91;
      -webkit-box-shadow: -1px 2px #001c91;
      -moz-box-shadow: -1px 2px #001c91;
      -o-box-shadow: -1px 2px #001c91;
    }

    div#barbutton3 {
      height: 13px;
      width: 50px;
      z-index: 1;

      position: absolute;
      top: 385px;
      left: 210px;

      border-radius: 100px;
      -webkit-border-radius: 100px;
      -moz-border-radius: 100px;
      -o-border-radius: 100px;

      background: linear-gradient(top, #50fb05 0%, #057b05 100%);
      background: -webkit-linear-gradient(top, #50fb05 0%, #057b05 100%);
      background: -moz-linear-gradient(top, #50fb05 0%, #057b05 100%);
      background: -o-linear-gradient(top, #50fb05 0%, #057b05 100%);

      box-shadow: -1px 2px #004200;
      -webkit-box-shadow: -1px 2px #004200;
      -moz-box-shadow: -1px 2px #004200;
      -o-box-shadow: -1px 2px #004200;
    }

    div#barbutton4 {
      height: 13px;
      width: 50px;
      z-index: 1;

      position: absolute;
      top: 385px;
      left: 270px;

      border-radius: 100px;
      -webkit-border-radius: 100px;
      -moz-border-radius: 100px;
      -o-border-radius: 100px;

      background: linear-gradient(top, #fb6505 0%, #bb0505 100%);
      background: -webkit-linear-gradient(top, #fb6505 0%, #bb0505 100%);
      background: -moz-linear-gradient(top, #fb6505 0%, #bb0505 100%);
      background: -o-linear-gradient(top, #fb6505 0%, #bb0505 100%);

      box-shadow: -1px 2px #7b0000;
      -webkit-box-shadow: -1px 2px #7b0000;
      -moz-box-shadow: -1px 2px #7b0000;
      -o-box-shadow: -1px 2px #7b0000;
    }

    div#miniButtonGlass4 {
      width: 15px;
      height: 15px;
      float: left;
      z-index: 1;

      position: absolute;
      top: 383px;
      left: 25px;

      box-shadow: 0 0 10px #490000;
      -webkit-box-shadow: 0 0 10px #490000;
      -moz-box-shadow: 0 0 10px #490000;
      -o-box-shadow: 0 0 10px #490000;

      border-radius: 20px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      -o-border-radius: 20px;

      background: radial-gradient(#ff9b5b, #fb6505);
      background: -webkit-radial-gradient(#ff9b5b, #fb6505);
      background: -moz-radial-gradient(#ff9b5b, #fb6505);
      background: -o-radial-gradient(#ff9b5b, #fb6505);
    }

    div#miniButtonGlass5 {
      width: 15px;
      height: 15px;
      float: left;
      z-index: 1;

      position: absolute;
      top: 383px;
      left: 51px;

      box-shadow: 0 0 10px #490000;
      -webkit-box-shadow: 0 0 10px #490000;
      -moz-box-shadow: 0 0 10px #490000;
      -o-box-shadow: 0 0 10px #490000;

      border-radius: 20px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      -o-border-radius: 20px;

      background: radial-gradient(#0abd0a, #057b05);
      background: -webkit-radial-gradient(#0abd0a, #057b05);
      background: -moz-radial-gradient(#0abd0a, #057b05);
      background: -o-radial-gradient(#0abd0a, #057b05);
    }

    div#yellowBox1 {
      width: 140px;
      height: 70px;
      z-index: 1;
      background-color: #ffff00;

      position: absolute;
      top: 415px;
      left: 25px;

      border-radius: 15px;
      -webkit-border-radius: 15px;
      -moz-border-radius: 15px;
      -o-border-radius: 15px;

      box-shadow: 0 0 20px #ff6600 inset;
      -webkit-box-shadow: 0 0 20px #ff6600 inset;
      -moz-box-shadow: 0 0 20px #ff6600 inset;
      -o-box-shadow: 0 0 20px #ff6600 inset;
    }

    div#yellowBox2 {
      width: 140px;
      height: 70px;
      z-index: 1;
      background-color: #ffff00;

      position: absolute;
      top: 415px;
      left: 185px;

      border-radius: 15px;
      -webkit-border-radius: 15px;
      -moz-border-radius: 15px;
      -o-border-radius: 15px;

      box-shadow: 0 0 20px #ff6600 inset;
      -webkit-box-shadow: 0 0 20px #ff6600 inset;
      -moz-box-shadow: 0 0 20px #ff6600 inset;
      -o-box-shadow: 0 0 20px #ff6600 inset;
    }
  }

  @media handheld and (orientation: portrait), (max-width: 768px) {
    div#pokedex {
      width: 400px;
    }

    div#logo {
      width: 281px;
      height: 99px;
      background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/200653/logo.png")
        no-repeat left top;
      z-index: 1;

      position: absolute;
      top: 220px;
      left: 30px;
    }

    div#left {
      width: 400px;
      height: 500px;
      float: left;
      position: relative;
      z-index: 1;
      margin: 0 auto;
    }

    div#curve1_left {
      width: 201px;
      height: 85px;
      background-color: #8b0000;
      float: left;
      padding: 15px 0 0 15px;

      position: absolute;
      top: 0;
      left: 0;

      box-shadow: 0 0 #5e0000;
      -webkit-box-shadow: 0 0 #5e0000;
      -moz-box-shadow: 0 0 #5e0000;
      -o-box-shadow: 0 0 #5e0000;

      border-bottom-right-radius: 85px 60px;
      -webkit-border-bottom-right-radius: 85px 60px;
      -moz-border-bottom-right-radius: 85px 60px;
      -o-border-bottom-right-radius: 85px 60px;

      border-top-left-radius: 30px;
      -webkit-border-top-left-radius: 30px;
      -moz-border-top-left-radius: 30px;
      -o-border-top-left-radius: 30px;
    }

    div#bg_curve1_left {
      width: 400px;
      height: 80px;
      background-color: #8b0000;

      box-shadow: -10px 9px #5e0000;
      -webkit-box-shadow: -10px 9px #5e0000;
      -moz-box-shadow: -10px 9px #5e0000;
      -o-box-shadow: -10px 9px #5e0000;

      border-top-left-radius: 30px;
      -webkit-border-top-left-radius: 30px;
      -moz-border-top-left-radius: 30px;
      -o-border-top-left-radius: 30px;
    }

    div#right,
    div#screen,
    div#bigbluebutton,
    div#barbutton1,
    div#barbutton2,
    div#cross {
      display: block;
    }
  }
</style>
